import { formattedNumberValueGetter } from './numberFormatter';

const bidModificationValueGetter = (value, dataRow, params, additionalData) => {
    const { getBidModificationValues, currencyRenderParams } = params;
    const { actualBid } = getBidModificationValues(dataRow, value);
    return formattedNumberValueGetter(actualBid, dataRow, currencyRenderParams, additionalData);
};

export default bidModificationValueGetter;
